/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  clone: {
    title: 'Pull departments from the directory',
    hint: 'Add the departments found in the integration source to the departments list',
    source: 'Integration source',
    sourcePlaceholder: 'Choose an integration source',
    note: 'Only new departments are added; nothing existing is deleted or changed.',
    notePrunes: 'New departments are added. After a successful user sync, unused departments from that source that have been empty for a day can be removed according to the cleanup setting.',
    submit: 'Pull departments',
    running: 'Please wait...',
  },

  purge: {
    confirm:
      'Every department pulled from the integration source that has no members will be deleted. This cannot be undone.',
  },

  actionDone: 'Operation Completed Successfully',
  actionFailed: 'The operation could not be completed, please try again',
  fail: {
    action: 'Could not complete the operation on this department',
    assign: 'Could not assign the users to the departments',
  },
  title: 'Departments',
  subtitle: 'Add a new department / group, or edit an existing one.',
  cardTitle: 'Departments / Groups',

  stats: {
    caption: 'Departments and groups at a glance',
    /* The card is the list's "no type filter" scope, so it names the list rather than
       counting it. `members` beside it stays a figure - see the page. */
    all: 'All groups',
    departments: 'Departments',
    privateGroups: 'Users Special Groups',
    members: 'Total users',
  },

  columns: {
    index: '#',
    name: 'Name',
    type: 'Type',
    createdOn: 'Creation Date',
    usersCount: 'User Number',
  },

  actions: {
    add: 'Add',
    createGroup: 'Add a department / group',
    update: 'Update',
    syncDepartments: 'Fetch and synchronize departments',
    bulkFromExcel: 'Update employees departments from an Excel',
    cloneFromDirectory: 'Pull departments from the directory',
    purgeEmptySynced: 'Delete empty synced departments',
    deleteEmptySync: 'Delete Active Directory Groups With No Users',
  },

  row: {
    sendEmail: 'Send Email',
    edit: 'Update',
    users: 'Users List',
    delete: 'Delete',
  },

  form: {
    title: 'Add a department / group',
    hint: 'This feature is used to manually add a department. It is recommended not to add administrative departments if the system is connected to a data source and synchronization is active or departments have already been fetched. Only special groups should be added in such cases',
    type: 'Group category',
    arabicName: 'Arabic Name',
    englishName: 'English Name',
    save: 'Save',
    required: 'Field required',
    lengthError: 'Text must be with in 3 to 200 letters.',
    createdMessage: 'The department was added successfully',
    updatedMessage: 'The department was updated successfully',
  },

  usersModal: {
    title: 'Users List',
    hint: 'if you want to remove users from group just select from table and click remove users',
    columns: {
      index: 'ID',
      userName: 'Username',
      name: 'Full name',
      email: 'Email',
      status: 'Status',
    },
    removeUsers: 'Delete Selected',
    addUsers: 'Add Users',
    exportExcel: 'Export to Excel',
    exportPdf: 'Export to PDF',
    search: 'Search by username, name or email',
    show: 'Show',
    entries: 'entries',
    perPage: 'Entries per page',
    searchLabel: 'Search:',
  },

  addUsersModal: {
    title: 'Users Special Groups',
    tabs: {
      list: 'Users List',
      excel: 'Execl Upload',
    },
    hint: 'if you want to add users to the group just select from table and click save',
    groupLabel: 'Departments:',
    groupPlaceholder: 'Group',
    columns: {
      index: 'ID',
      userName: 'Username',
      nameAr: 'Arabic Name',
      nameEn: 'English Name',
      email: 'Email',

      group: 'Group',
    },
    save: 'Save',
    nothingSelected: 'no users has been selected from table or added in excel',
    search: 'Search by username, name or email',
  },

  unknownUsersModal: {
    title: 'Usernames that were not found',
    lead: 'The remaining users were added to the department.',
    hint: 'Check the spelling of the names below and add them again, or export them to Excel to review.',
    search: 'Search by username',
    count: (shown, total) => `${shown} of ${total}`,
    empty: 'No name matches the search',
    fileName: (group) => `Names not found - ${group}`,

    sheetName: 'Names not found',
    exportFailed: 'The file could not be exported',
  },

  emailModal: {
    title: 'Send Email',
    messageTitle: 'Message Title',
    sendDate: 'Send Date',
    messageBody: 'Sms Body',
    previousNotifications: 'Previous Notifications',
    submit: 'Schedule Sending',
    missingTitle: 'Missing Message Title',
    missingSendTime: 'Missing Send Time',
    missingBody: 'Missing Message Body',
    success: 'Request processed successfully',
    datePlaceholder: 'ex. 2020-10-01 17:00',
  },

  bulkModal: {
    title: 'Update employees departments from an Excel',
    hint: 'This feature is used to update employee departments in cases where synchronization is not active, or the integration source is outdated and does not contain complete department data, and departments have been entered manually. (used to update groups with department types only)',
    submit: 'Update',
    missingFile: 'Please fill user excel file then upload it again',
    success: 'Request processed successfully',
  },

  excel: {
    intro: 'Please upload a file in Excel (.xlsx) or CSV (.csv) format',
    introXlsxOnly: 'Please upload a file in Excel (.xlsx) format',
    columnsIntro: 'The file must contain the following columns',
    mandatory: 'Mandatory',
    optional: 'Optional',
    notesTitle: 'Important Notes',
    notes:
      'The first row in the file must contain the column names, exactly matching the names and order shown in the table',
    template: 'Download template',
  },

  deleteConfirm: 'Do you really want to delete this group?',
  close: 'Close',
}
